import { request } from "./http";

// Professionals alias employees in the UI
export const listProfessionals = () =>
  request<import("../types").Professional[]>("/api/employees");

export const listEmployees = () =>
  request<import("../types").Employee[]>("/api/employees");

export const createEmployee = (body: {
  name: string;
  email: string;
  password: string;
  is_admin?: boolean;
  color?: string | null;
  capacity?: number;
}) =>
  request<import("../types").Employee>("/api/employees", { method: "POST", body: JSON.stringify(body) });

export const updateEmployee = (
  id: number | string,
  body: Partial<{
    name: string;
    email: string;
    password: string;
    is_admin: boolean;
    color: string | null;
    capacity: number;
  }>,
) =>
  request<Partial<import("../types").Employee>>(`/api/employees/${id}`, { method: "PUT", body: JSON.stringify(body) });

export const deleteEmployee = (id: number | string) =>
  request<void>(`/api/employees/${id}`, { method: "DELETE" });

export const getEmployee = (id: number | string) =>
  request<import("../types").Employee>(`/api/employees/${id}`);

// Backwards-compatible aliases using "Professional" naming in UI code
export const createProfessional = createEmployee;
export const updateProfessional = updateEmployee;
export const deleteProfessional = deleteEmployee;
export const getProfessional = getEmployee;
